//#region import libraries

import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

//bootstrap
import { Row, Col, Button } from 'react-bootstrap';

//custom componets
import { CustomSpinner, NewScreen, Title } from '_components/atoms';
import AdjustmentSeasonForm from '_components/molecules/assistance-bookings/create-season-variance-form';

//redux
import { useDispatch, useSelector } from 'react-redux';
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';
import { selectAddSeasonalVariancesStatus, resetStatus, selectDeleteSeasonalVariancesStatus, selectSeasonalVariances } from '_redux/slices/prm-bookings/seasonal-variance';
import { getSeasonalVariance, deleteSeasonalVariance } from '_redux/slices/prm-bookings/seasonal-variance';
import { Colors, Spacing } from '_styles';

//icons
import { IoMdClose } from "react-icons/io";

// tremor
import { Flex, Title as TitleModal } from "@tremor/react";

//#endregion

const modalStyle = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "60%",       // Adjust the width to make the modal wider
        // height: "40%",      // Adjust the height to make the modal taller
        // maxWidth: "1000px", // Optional: limit the maximum width
        // maxHeight: "700px", // Optional: limit the maximum height
        padding: "20px",    // Optional: add padding inside the modal
    },
};


const SeasonalVariances = () => {

    //#region redux

    const dispatch = useDispatch();

    const dbUser = useSelector(selectFirebaseInfo);

    const seasonalAdjustments = useSelector(selectSeasonalVariances);

    // status flags    
    const addSeasonVarianceStatus = useSelector(selectAddSeasonalVariancesStatus);
    const deleteSeasonVarianceStatus = useSelector(selectDeleteSeasonalVariancesStatus);

    //#endregion


    //#region local state

    const [showAddModal, setShowAddModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedVarianceTag, setSelectedVarianceTag] = useState(null)

    //#endregion


    const SeasonAdjustmentItem = ({ adjustment }) => {
        return (
            <Row className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">

                <Col className="d-flex  align-items-center">
                    <span className="me-2 text-muted">{new Date(adjustment.startDate).toLocaleDateString()}</span>
                    <span className="me-2 text-muted">-</span>
                    <span className="me-2 text-muted">{new Date(adjustment.endDate).toLocaleDateString()}</span>
                </Col>

                <Col>
                    <span className="text-muted">{adjustment.tag ? adjustment.tag : "Not applicable"}</span>
                </Col>

                {/* variance + delete button*/}
                <Col className="d-flex flex-start mt-2">
                    <div style={{
                        display: 'flex',
                        //borderStyle:'solid', borderWidth:1
                    }}>
                        <p style={{ color: adjustment.multiplier > 0 ? 'green' : 'red' }}>{adjustment.multiplier > 0 ? '+' : ''}</p>
                        <p style={{ color: adjustment.multiplier > 0 ? 'green' : 'red' }}>{adjustment.multiplier * 100 + ' %'}</p>
                    </div>
                </Col>

                <Col>
                    <Button onClick={() => handleDelete(adjustment.tag)} variant="outline-danger">
                        <IoMdClose size={22} />
                    </Button>
                </Col>
            </Row>
        );
    }

    //#endregion

    //#region functions    

    const handleDelete = (tag) => {
        setSelectedVarianceTag(tag)
        setDeleteModal(true)

    }

    const handleCloseModal = () => {
        setShowAddModal(false); // close modal
        setSelectedVarianceTag(null)
    };
    const handleCloseDeleteModal = () => {
        setDeleteModal(false); // close modal
        setSelectedVarianceTag(null)
    };

    const handleOpenModal = () => {
        setShowAddModal(true)
    }

    const confirmDelete = () => {
        const data = { iata: dbUser.details.authority, tag: selectedVarianceTag }
        dispatch(deleteSeasonalVariance(data))
        setSelectedVarianceTag(null);
        setDeleteModal(false);
    }
    //#endregion

    //#region useEffects
    useEffect(() => {
        if ((addSeasonVarianceStatus === "succeeded" || deleteSeasonVarianceStatus === "succeeded") && dbUser) {
            dispatch(getSeasonalVariance(dbUser.details.authority))
        }
    }, [addSeasonVarianceStatus, deleteSeasonVarianceStatus])
    //reset all flags 
    useEffect(() => {
        dispatch(resetStatus())
    }, []);

    useEffect(() => {
        if (dbUser && dbUser.details.type === "AIRPORT") {
            dispatch(getSeasonalVariance(dbUser.details.authority))
        }
    }, [dbUser]);

    //#endregion
    return (
        <NewScreen>

            {/* title */}
            <Row>
                <Col>
                    <Title subtitle={"Seasonal Variance"} description={`Manualy add seasonal adjustments to PRM forecast by adding a date range and percentage increase/decrease `} />
                </Col>
            </Row>

            {/* list of seasonal adjustments cards */}
            <Row>
                {seasonalAdjustments && seasonalAdjustments.seasonalAdjustments && seasonalAdjustments.seasonalAdjustments?.length != undefined && seasonalAdjustments.seasonalAdjustments?.length != 0 ?
                    seasonalAdjustments.seasonalAdjustments.map(adjustment => (
                        <SeasonAdjustmentItem key={adjustment.tag} adjustment={adjustment} />))
                    :
                    <></>
                }
            </Row>

            {/* add button */}
            <Row>
                <Button onClick={handleOpenModal}>{'Add Seasonal Variance'}</Button>
            </Row>

            {/*modal to add new variance */}
            <Modal
                isOpen={showAddModal}               // modal open if true
                onAfterOpen={() => { }}             // called after modal is opened
                onRequestClose={handleCloseModal}   // close modal handler
                style={modalStyle}                  // modal styling
                transparent={true}                  // shows background behind modal
            >
                <AdjustmentSeasonForm closeModal={handleCloseModal} />
            </Modal>

            {/* modal to delete variance!*/}
            <Modal
                isOpen={deleteModal}
                onRequestClose={handleCloseDeleteModal}
                contentLabel="Delete Variance"
                style={modalStyle} // modal styling
                transparent={true} // shows background behind modal
            >
                <div style={{ padding: Spacing.SCALE_12, opacity: deleteSeasonVarianceStatus === "loading" ? 0.3 : 1.0 }}>

                    <div style={{ marginLeft: Spacing.SCALE_12, marginTop: Spacing.SCALE_12, textAlign: 'center', width: '100%' }}        >
                        <TitleModal>Delete Variance</TitleModal>
                    </div>

                    <hr color={Colors.PRM_LIGHT_BLUE} />
                    <div style={{ marginLeft: Spacing.SCALE_12, marginRight: Spacing.SCALE_12, marginTop: Spacing.SCALE_38, height: Spacing.SCALE_38 }}>
                        {deleteSeasonVarianceStatus === 'loading' ?
                            <CustomSpinner /> : <p style={{ margin: 0, padding: 0, fontSize: "18px", height: "24px" }}></p>}
                    </div>
                    {/* button of modal */}
                    <div style={{ marginTop: Spacing.SCALE_22 }}>
                        <Flex>
                            <Button variant={"primary"} onClick={() => { setDeleteModal(false), dispatch(setSelectedVarianceTag(null)) }}>Cancel</Button>
                            <Button variant={"danger"} onClick={confirmDelete}  >Delete</Button>
                        </Flex>
                    </div>
                </div>
            </Modal>
        </NewScreen>
    )
}

export default SeasonalVariances
